<template>
  <div
    class="container lms-wrapper-two"
  >
    <student-nav @route-changed="toggleNavbar(false)"></student-nav>
    <!-- <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <vue-custom-scrollbar :style="`height: ${scrollHeight.nav}px`">
          <div :class="`card ${$store.state.app.isMobile ? 'bd-0' : ''}`">
            <div class="card-body">
              
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div> -->
    <div class="lms-content">
      <student-header ref="lmsv4header" class="filled" />
      <div class="lms-content-body" style="height: calc(100vh - 80px);">
        <div class="bg-white rounded-20 mg-30 pd-30" >
          <ul class="steps">
            <li class="step-item" :class="{ active: stepCur == 1 }">
              <a href="#" class="step-link">
                <span class="step-number">1</span>
                <span class="step-title">Видео үзэх</span>
              </a>
            </li>
            <li class="step-item" :class="{ active: stepCur == 2 }">
              <a href="#" class="step-link">
                <span class="step-number">2</span>
                <span class="step-title">Бататгах шалгалт</span>
              </a>
            </li>
            <li class="step-item" :class="{ active: stepCur == 3 }">
              <a href="#" class="step-link">
                <span class="step-number">3</span>
                <span class="step-title">Ёс зүйн тайлан илгээх</span>
              </a>
            </li>
          </ul>
          <div v-if="ethiConfig.rdy" class="card mg-t-20">
            <div v-if="stepCur == 1" class="pd-10">
              <div style="position: relative;">
                <file-preview
                  :id="ethiConfig.obj.fileId"
                  v-if="stepCur == 1"
                  :force="true"
                  :minusHeight="200"
                />
              </div>
              
              <div class="d-flex align-items-center">
                <div>
                  <div class="alert alert-warning" role="alert">
                    Видеог үзэж дууслаа товчийг дарснаар бататгах асуулга бөглөнө
                  </div>
                </div>
                <div class="mg-l-auto">
                  <button
                    @click="videoNext()"
                    class="btn btn-xs btn-primary btn-uppercase"
                    role="button"
                  >
                    Бататгах шалгалт
                    <feather type="arrow-right"></feather>
                  </button>
                </div>
              </div>
            </div>
            <div v-else-if="stepCur == 2" class="pd-10">
              <exam-fill
                v-if="ethiConfig.rdy"
                :ethicReportConfig="ethiConfig.obj.ethicReportConfig"
                :propExamId="ethiConfig.obj.examId"
                :propCourseId="ethiConfig.obj.ethicReportConfig.id"
                @on-congrats="examCongrats"
              />
            </div>
            <div v-else-if="stepCur == 3">
              <div
                class="row no-gutters"
                v-if="$store.state.app.activeGroup.id == 9157"
              >
                <div class="col-sm-8 bd-r">
                  <div class="pd-20 overflow-y-auto" style="height: 70vh">
                    <label
                      class="
                        tx-sans tx-13
                        bd-b
                        tx-semibold tx-uppercase tx-color-01 tx-spacing-1
                        mg-b-15
                      "
                      >1. Гишүүний үүргийн биелэлт</label
                    >
                    <div>
                      <div class="row">
                        <div class="col-sm-5">
                          <table class="table table-bordered" v-if="hrm.rdy">
                            <tbody>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  Тайлант он
                                </th>
                                <td>{{ new Date().getFullYear() }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  Гэрчилгээний №
                                </th>
                                <td>{{ hrm.obj.loginName }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  Харъяалагдах салбар
                                </th>
                                <td>{{ $store.state.user.userInfo.depart }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  Ургийн овог
                                </th>
                                <td>{{ hrm.obj.st5 }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  Эцэг/ Эхийнн нэр
                                </th>
                                <td>{{ $store.state.user.userInfo.ovog }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  Нэр
                                </th>
                                <td>{{ $store.state.user.userInfo.ner }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  И-мэйл хаяг
                                </th>
                                <td>{{ $store.state.user.userInfo.mail }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col-sm-7">
                          <table class="table" v-if="hrm.rdy">
                            <tbody>
                              <tr>
                                <th scope="row" class="text-right">
                                  Ажилладаг салбар
                                </th>
                                <td>
                                  <Select
                                    v-model="hrm.obj.locTypeId7"
                                    class="wd-100p"
                                    clearable
                                  >
                                    <Option
                                      :value="t.id"
                                      :label="t.title"
                                      v-for="(t, i) in hrm.types"
                                      :key="i"
                                    ></Option>
                                  </Select>
                                </td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right">
                                  Албан газрын нэр
                                </th>
                                <td>
                                  <input
                                    v-model="hrm.obj.address"
                                    class="form-control"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right">
                                  Албан тушаалын нэр
                                </th>
                                <td>
                                  <input
                                    v-model="hrm.obj.position"
                                    class="form-control"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right">
                                  Утасны дугаар
                                </th>
                                <td>
                                  <input
                                    v-model="hrm.obj.mobile"
                                    class="form-control"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <label
                      class="
                        tx-sans tx-13
                        bd-b
                        tx-semibold tx-uppercase tx-color-01 tx-spacing-1
                        mg-b-15
                      "
                      >2. МНБ Гишүүний ерөнхий мэдээлэл</label
                    >
                    <div>
                      <div class="form-group">
                        <label for="formGroupExampleInput" class="d-block"
                          >1. Мэргэжлийн ёс зүйг чанд сахиж ажил үүргээ
                          гүйцэтгэхэд шаардлагатай ур чадварыг олж авахын тулд
                          өөрийгөө тасралтгүй хөгжүүлсэн</label
                        >
                        <Select
                          v-model="ethicModel.obj.too1"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >2. Нягтлан бодох бүртгэлийн тухай хууль, аудитын тухай
                          хууль болон бусад ажил мэргэжлийн холбогдолтой хууль,
                          тогтоомж, журам, дүрмийг мөрдөж ажилласан</label
                        >
                        <Select
                          v-model="ethicModel.obj.i2"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >3. Гэмт хэрэг, зөрчилд холбогдоогүй
                        </label>
                        <Select
                          v-model="ethicModel.obj.i3"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >4. Бусад мэргэшсэн нягтлан бодогчдын нэр төрд
                          халдаагүй, худал гүтгээгүй</label
                        >
                        <Select
                          v-model="ethicModel.obj.i4"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >5. Харилцагчийн мэдээллийн нууцыг чанд хадгалж, олон
                          нийтэд нээлттэй биш мэдээллийг өөрийн болон 3-дагч талын
                          тусын тулд ашиглаагүй</label
                        >
                        <Select
                          v-model="ethicModel.obj.i5"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >6. Хувийн ашиг сонирхлыг илүүд тавьж бодитой бус
                          шийдвэр гаргаагүй</label
                        >
                        <Select
                          v-model="ethicModel.obj.i6"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >7. Бусдын нөлөөнд автаж хэт нэг талыг барьсан шийдвэр
                          гаргаагүй</label
                        >
                        <Select
                          v-model="ethicModel.obj.i7"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >8. Санхүүгийн мэдээлэл бэлтгэхдээ санаатай буруу
                          мэдээлэл оруулаагүй</label
                        >
                        <Select
                          v-model="ethicModel.obj.i8"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >9. Мөнгө угаах терроризмыг санхүүжүүлэхтэй тэмцэх
                          үүргээ ухамсарлан ажиллаж байгаа</label
                        >
                        <Select
                          v-model="ethicModel.obj.days"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >10. Институт болон бусад мэргэжлийн байгууллагуудаас ёс
                          зүйн болон сахилгын шийтгэл хүлээгээгүй</label
                        >
                        <Select
                          v-model="ethicModel.obj.minutes"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <go-points :hideBorder="true" :hidePrint="true" />

                  <div class="pd-10 bd-t">
                    <div class="alert alert-info" role="alert">
                      Ёс зүйгээ дээдлэн ажиллаж байгаа МНБ гишүүн танд амжилт хүсье!
                    </div>
                    <button
                      @click="finishEthic()"
                      class="btn btn-xs btn-block btn-primary btn-uppercase"
                      role="button"
                    >
                      Ёс зүйн тайланг илгээх
                      <feather type="send"></feather>
                    </button>
                  </div>
                </div>
                <div class="mg-l-auto">
                  <button
                    @click="videoNext()"
                    class="btn btn-xs btn-primary btn-uppercase"
                    role="button"
                  >
                    Бататгах шалгалт
                    <feather type="arrow-right"></feather>
                  </button>
                </div>
              </div>
              <div
                class="row no-gutters"
                v-if="$store.state.app.activeGroup.id == 6126"
              >
                <div class="col-sm-8 bd-r">
                  <div class="pd-20 overflow-y-auto" style="height: 80vh">
                    
                    <div>
                      <div class="row">
                        <div class="col-sm-12">
                          <table class="table table-bordered" v-if="hrm.rdy">
                            <tbody>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  Тайлант он
                                </th>
                                <td>{{ new Date().getFullYear() }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  Гэрчилгээний №
                                </th>
                                <td>{{ hrm.obj.loginName }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  Харъяалагдах салбар
                                </th>
                                <td>{{ $store.state.user.userInfo.depart }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  Ургийн овог
                                </th>
                                <td>{{ hrm.obj.st5 }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  Эцэг/ Эхийнн нэр
                                </th>
                                <td>{{ $store.state.user.userInfo.ovog }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  Нэр
                                </th>
                                <td>{{ $store.state.user.userInfo.ner }}</td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right bg-gray-100">
                                  И-мэйл хаяг
                                </th>
                                <td>{{ $store.state.user.userInfo.mail }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <!-- <div class="col-sm-7">
                          <table class="table" v-if="hrm.rdy">
                            <tbody>
                              <tr>
                                <th scope="row" class="text-right">
                                  Ажилладаг салбар
                                </th>
                                <td>
                                  <Select
                                    v-model="hrm.obj.locTypeId7"
                                    class="wd-100p"
                                    clearable
                                  >
                                    <Option
                                      :value="t.id"
                                      :label="t.title"
                                      v-for="(t, i) in hrm.types"
                                      :key="i"
                                    ></Option>
                                  </Select>
                                </td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right">
                                  Албан газрын нэр
                                </th>
                                <td>
                                  <input
                                    v-model="hrm.obj.address"
                                    class="form-control"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right">
                                  Албан тушаалын нэр
                                </th>
                                <td>
                                  <input
                                    v-model="hrm.obj.position"
                                    class="form-control"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th scope="row" class="text-right">
                                  Утасны дугаар
                                </th>
                                <td>
                                  <input
                                    v-model="hrm.obj.mobile"
                                    class="form-control"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div> -->

                        <!-- <div class="row">
                          <div class="col-sm-2"></div>
                          <div class="col-sm-8 text-center">
                            Монгол Улсын татварын мэргэшсэн зөвлөх би Татварын
                            мэргэшсэн зөвлөх үйлчилгээний хүрээнд бүрэн эрхээ
                            хэрэгжүүлэхдээ хууль, тогтоомж, мэргэжлийн ёс зүйг
                            чандлан сахихаа нэр төртэйгээр батлан
                            <h3
                              class="font-weight-bolder my-3"
                              style="font-weight: 500"
                            >
                              ТАНГАРАГЛАЯ
                            </h3>
                            <h3 class="font-weight-bolder my-3">ТАНГАРАГЛАЯ</h3>
                            <h3 class="font-weight-bolder my-3">ТАНГАРАГЛАЯ</h3>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <template>
                      <label class="tx-sans tx-13 bd-b tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15">
                        1. Та татварын мэргэшсэн зөвлөх үйлчилгээний хүрээнд бүрэн эрхээ хэрэгжүүлэхдээ хууль, тогтоомж, мэргэжлийн ёс зүйг чандлан сахиж, өргөсөн тангарагаа нэр төртэйгөөр биелүүлсэн үү?
                      </label>
                      <div class="form-group pd-l-20">
                        <label>Хариулт</label>
                        <Select
                          v-model="ethicModel.obj.too2"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                      </div>

                      <label class="tx-sans tx-13 bd-b tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15">
                        2. Та ТМЗН-ийн холбогдох хууль, дүрэм, журмуудтай уншиж танилцсан эсэх:
                      </label>
                      <div class="form-group pd-l-20">
                        <label>Хариулт</label>
                        <Select
                          v-model="ethicModel.obj.i2"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in i2arr6126"
                            :key="i"
                          ></Option>
                        </Select>
                        <textarea v-if="ethicModel.obj.i2==2 || ethicModel.obj.i2==3" v-model="ethicModel.obj.s1" :placeHolder="ethicModel.obj.i2==3?'тайлбар бичнэ үү':'Танилцсан журмыг бичнэ үү /бүх журамтай танилцсан бол бүрэн танилцсан гэж бичнэ үү/'" class="form-control"></textarea>
                      </div>
                      <label class="tx-sans tx-13 bd-b tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15">
                        3. Та өмнөх онд татварын зөвлөх үйлчилгээтэй холбоотой үйл ажиллагаанд оролцсон эсэх:
                      </label>
                      <div class="form-group pd-l-20">
                        <label>Хариулт</label>
                        <Select v-model="ethicModel.obj.i3" class="wd-100p mg-b-15" clearable>
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in i3arr6126"
                            :key="i"
                          ></Option>
                        </Select>
                      </div>
                      
                      <label class="tx-sans tx-13 bd-b tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15">
                        4. Та татвараас зайлсхийх үйл ажиллагаанд оролцсон эсэх:
                      </label>
                      <div class="form-group pd-l-20">
                        <label>Хариулт</label>
                        <Select v-model="ethicModel.obj.i5" class="wd-100p mg-b-15" clearable>
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                      </div>

                      <label class="tx-sans tx-13 bd-b tx-semibold tx-uppercase tx-color-01 tx-spacing-1">
                        5. Та мэргэшсэн эрхийн нэмэгдэл авдаг уу?
                      </label>
                      <div class="mg-b-15 text-right" style="font-style: italic">/“Нягтлан бодох бүртгэлийн тухай хууль”-ийн 23 дугаар зүйлийн 23.1 дэх хэсэгт заасан/</div>
                      <div class="form-group pd-l-20">
                        <label>Хариулт</label>
                        <Select
                          v-model="ethicModel.obj.i4"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                        <!-- <Select v-if="ethicModel.obj.i4==1"
                          v-model="ethicModel.obj.i5"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in i5arr6126"
                            :key="i"
                          ></Option>
                        </Select> -->
                        <input v-if="ethicModel.obj.i4==-1" v-model="ethicModel.obj.s2" placeHolder="тайлбар бичнэ үү" class="form-control" />
                      </div>

                      <label class="tx-sans tx-13 bd-b tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15">
                        6. Нийгэмлэгээс зохион байгуулдаг тасралтгүй боловсролын сургалтад хамрагдсан уу?
                      </label>
                      <div class="form-group pd-l-20">
                        <label>Хариулт</label>
                        <Select
                          v-model="ethicModel.obj.i6"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in i6arr6126"
                            :key="i"
                          ></Option>
                        </Select>
                        <input v-if="ethicModel.obj.i6==-1" v-model="ethicModel.obj.s6" placeHolder="тайлбар бичнэ үү" class="form-control" />
                      </div>

                      <label class="tx-sans tx-13 bd-b tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15">
                        7. Нийгэмлэгийн үйл ажиллагаанд таны оролцоо, хувь нэмэр:
                      </label>
                      <div class="form-group pd-l-20">
                        <label>Хариулт</label>
                        <Select
                          v-model="ethicModel.obj.i7"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in i7arr6126"
                            :key="i"
                          ></Option>
                        </Select>
                        <input v-if="ethicModel.obj.i7==1" v-model="ethicModel.obj.s4" placeHolder="Аль хороо, салбарын ямар үйл ажиллагаанд оролцсон тухай бичнэ үү" class="form-control" />
                        <input v-else-if="ethicModel.obj.i7==2" v-model="ethicModel.obj.s4" placeHolder="Ямар үйл ажиллагаанд оролцсон тухай бичнэ үү" class="form-control" />
                        <input v-else-if="ethicModel.obj.i7==3" v-model="ethicModel.obj.s4" placeHolder="Ямар үйл ажиллагаанд оролцсон тухай бичнэ үү" class="form-control" />
                        <input v-else-if="ethicModel.obj.i7==4" v-model="ethicModel.obj.s4" placeHolder="Оролцоогүй бол яагаад, танд ямар санал байна?" class="form-control" />
                      </div>

                      <label class="tx-sans tx-13 bd-b tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15">
                        8. Та нийгэмлэгтэй холбоотой мэдээ, мэдээллийг ямар эх сурвалжаас авдаг вэ?
                      </label>
                      <div class="form-group pd-l-20">
                        <label>Хариулт</label>
                        <Select
                          v-model="ethicModel.obj.i8"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in i8arr6126"
                            :key="i"
                          ></Option>
                        </Select>
                        <input v-if="ethicModel.obj.i8==4" v-model="ethicModel.obj.s7" placeHolder="хаанаас" class="form-control" />
                      </div>

                      <!-- <label class="tx-sans tx-13 bd-b tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15">
                        8. Гишүүний програмтай бүрэн танилцсан эсэх:
                      </label>
                      <div class="form-group pd-l-20">
                        <label>Хариулт</label>
                        <Select
                          v-model="ethicModel.obj.too1"
                          class="wd-100p"
                          clearable
                        >
                          <Option
                            :value="p.id"
                            :label="p.title"
                            v-for="(p, i) in YesNoArrs"
                            :key="i"
                          ></Option>
                        </Select>
                        <input v-if="ethicModel.obj.too1==-1" v-model="ethicModel.obj.s5" placeHolder="тайлбар бичнэ үү" class="form-control" />
                      </div> -->
                    </template>
                    <template v-if="1 == 2">
                      <label
                        class="
                          tx-sans tx-13
                          bd-b
                          tx-semibold tx-uppercase tx-color-01 tx-spacing-1
                          mg-b-15
                        "
                        >2. Гишүүний ерөнхий мэдээлэл</label
                      >
                      <div>
                        <div class="form-group">
                          <label for="formGroupExampleInput" class="d-block"
                            >1. Шударга ёс, бодит байдлыг хангасан эсэх</label
                          >
                          <Select
                            v-model="ethicModel.obj.too1"
                            class="wd-100p"
                            clearable
                          >
                            <Option
                              :value="p.id"
                              :label="p.title"
                              v-for="(p, i) in BurenHangasanArrs"
                              :key="i"
                            ></Option>
                          </Select>
                        </div>
                        <div class="form-group">
                          <label for="formGroupExampleInput2" class="d-block"
                            >2. Хараат бус байдлыг хангасан эсэх:</label
                          >
                          <Select
                            v-model="ethicModel.obj.i2"
                            class="wd-100p"
                            clearable
                          >
                            <Option
                              :value="p.id"
                              :label="p.title"
                              v-for="(p, i) in BurenHangasanArrs"
                              :key="i"
                            ></Option>
                          </Select>
                        </div>
                        <div class="form-group">
                          <label for="formGroupExampleInput2" class="d-block"
                            >3. Гишүүний мэргэжлийн үйлчилгээний чанар, ёс зүйд
                            хамаарах шаардлагуудыг хангасан эсэх
                          </label>
                          <Select
                            v-model="ethicModel.obj.i3"
                            class="wd-100p"
                            clearable
                          >
                            <Option
                              :value="p.id"
                              :label="p.title"
                              v-for="(p, i) in BurenHangasanArrs"
                              :key="i"
                            ></Option>
                          </Select>
                        </div>
                        <div class="form-group">
                          <label for="formGroupExampleInput2" class="d-block"
                            >4. Мэргэжлийн мэдлэг, ур чадвар, хянамгай байдлыг
                            хэрэгжүүлсэн эсэх</label
                          >
                          <Select
                            v-model="ethicModel.obj.i4"
                            class="wd-100p"
                            clearable
                          >
                            <Option
                              :value="p.id"
                              :label="p.title"
                              v-for="(p, i) in BurenHangasanArrs"
                              :key="i"
                            ></Option>
                          </Select>
                        </div>
                        <div class="form-group">
                          <label for="formGroupExampleInput2" class="d-block"
                            >5. Мэдээллийн нууцыг хадгалах шаардлагыг хангасан
                            эсэх</label
                          >
                          <Select
                            v-model="ethicModel.obj.i5"
                            class="wd-100p"
                            clearable
                          >
                            <Option
                              :value="p.id"
                              :label="p.title"
                              v-for="(p, i) in BurenHangasanArrs"
                              :key="i"
                            ></Option>
                          </Select>
                        </div>
                        <div class="form-group">
                          <label for="formGroupExampleInput2" class="d-block"
                            >6. Мэргэжлийн нэр хүндийг дээдлэн ажилласан
                            эсэх</label
                          >
                          <Select
                            v-model="ethicModel.obj.i6"
                            class="wd-100p"
                            clearable
                          >
                            <Option
                              :value="p.id"
                              :label="p.title"
                              v-for="(p, i) in BurenHangasanArrs"
                              :key="i"
                            ></Option>
                          </Select>
                        </div>
                        <div class="form-group">
                          <label for="formGroupExampleInput2" class="d-block"
                            >7. Гишүүний ёс зүйн бусад шаардлагуудыг хангасан
                            эсэх</label
                          >
                          <Select
                            v-model="ethicModel.obj.i7"
                            class="wd-100p"
                            clearable
                          >
                            <Option
                              :value="p.id"
                              :label="p.title"
                              v-for="(p, i) in BurenHangasanArrs"
                              :key="i"
                            ></Option>
                          </Select>
                        </div>
                        <div class="form-group">
                          <label for="formGroupExampleInput2" class="d-block"
                            >8. Гишүүний татвараа төлсөн эсэх</label
                          >
                          <Select
                            v-model="ethicModel.obj.i8"
                            class="wd-100p"
                            clearable
                          >
                            <Option
                              :value="p.id"
                              :label="p.title"
                              v-for="(p, i) in TulburTulsunArrs"
                              :key="i"
                            ></Option>
                          </Select>
                        </div>
                        <div class="form-group">
                          <label for="formGroupExampleInput2" class="d-block"
                            >9. Тасралтгүй боловсролын шаардлагуудыг хангасан
                            эсэх</label
                          >
                          <Select
                            v-model="ethicModel.obj.days"
                            class="wd-100p"
                            clearable
                          >
                            <Option
                              :value="p.id"
                              :label="p.title"
                              v-for="(p, i) in TasBolovsrolArrs"
                              :key="i"
                            ></Option>
                          </Select>
                        </div>
                        <div class="form-group">
                          <label for="formGroupExampleInput2" class="d-block"
                            >10. Нийгэмлэгээс зохион байгуулдаг арга хэмжээнд
                            оролцдог эсэх</label
                          >
                          <Select
                            v-model="ethicModel.obj.minutes"
                            class="wd-100p"
                            clearable
                          >
                            <Option
                              :value="p.id"
                              :label="p.title"
                              v-for="(p, i) in EventArrs"
                              :key="i"
                            ></Option>
                          </Select>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="col-sm-4">
                  <go-points :hideBorder="true" :hidePrint="true" style="overflow: auto; max-height: 58vh" />
                  <div class="pd-10 bd-t">
                    <div class="alert alert-info" role="alert">
                      Ёс зүйгээ дээдлэн ажиллаж байгаа ТМЗ гишүүн танд амжилт
                      хүсье!
                    </div>
                    <button
                      @click="finishEthic()"
                      class="btn btn-xs btn-block btn-primary btn-uppercase"
                      role="button"
                    >
                      Ёс зүйн тайланг илгээх
                      <feather type="send"></feather>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import "element-ui/lib/theme-chalk/index.css";
import { Select, Option, Notification } from "element-ui";

export default {
  components: {
    Select,
    Option,
    vueCustomScrollbar,
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    examFill: () => ({
      component: import("@/views/main/exam.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    goPoints: () => ({
      component: import("@/views/modules/lms/components/points"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      scrollHeight: {
        contentToolbarHeight: 49,
        nav: 0,
        content: 0,
        right: 0,
      },
      ethiConfig: {
        obj: {},
        rdy: false,
      },
      stepCur: 1,
      hrm: {
        obj: {},
        types: [],
        rdy: false,
      },
      ethicModel: {
        obj: {
          id: 0,
        },
        rdy: false,
      },
      YesNoArrs: [
        {id: 0, title: 'Сонгох'},
        { id: 1, title: "Тийм" },
        { id: -1, title: "Үгүй" },
      ],
      BurenHangasanArrs: [
        //{id: 0, title: 'Сонгох'},
        { id: 2, title: "Бүрэн хангасан" },
        { id: 1, title: "Хангасан" },
        { id: -1, title: "Хангалтгүй" },
      ],
      TulburTulsunArrs: [
        //{id: 0, title: 'Сонгох'},
        { id: 2, title: "Хугацаандаа төлсөн" },
        { id: 1, title: "Хугацаа хэтрүүлж төлсөн" },
        { id: -1, title: "Төлөөгүй" },
      ],
      TasBolovsrolArrs: [
        //{id: 0, title: 'Сонгох'},
        { id: 2, title: "3 ба түүнээс дээш сургалтад хамрагдсан" },
        { id: 1, title: "1-2 сургалтад хамрагдсан" },
        { id: -1, title: "Сургалтад хамрагдаагүй" },
      ],
      EventArrs: [
        //{id: 0, title: 'Сонгох'},
        { id: 2, title: "2 ба түүнээс дээш удаа оролцсон" },
        { id: 1, title: "1 удаа оролцсон" },
        { id: -1, title: "Огт оролцоогүй" },
      ],
      b: {},
      parentTask: {},
      i2arr6126: [
        {id: 0, title: 'Сонгох'},
        { id: 1, title: "ТМЗҮТХ болон холбогдох дүрэм, журамтай бүрэн танилцсан" },
        { id: 2, title: "Заримтай нь танилцсан" },
        { id: 3, title: "Танилцаагүй бол яагаад" },
      ],
      i3arr6126: [
        {id: 0, title: 'Сонгох'},
        { id: 1, title: "2 ба түүнээс дээш удаа оролцсон" },
        { id: 2, title: "1 удаа оролцсон" },
        { id: 3, title: "Оролцоогүй" },
      ],
      i5arr6126: [
        {id: 0, title: 'Сонгох'},
        { id: 1, title: "Зөвхөн ТМЗ-ийн нэмэгдэл авдаг" },
        { id: 2, title: "Зөвхөн МНБ-ийн нэмэгдэл авдаг" },
        { id: 3, title: "ТМЗ, МНБ аль алинаар нь нэмэгдэл авдаг" },
      ],
      i6arr6126: [
        {id: 0, title: 'Сонгох'},
        { id: 1, title: "3 ба түүнээс дээш сургалтад хамрагдсан" },
        { id: 2, title: "1-2 сургалтад хамрагдсан" },
        { id: 3, title: "Сургалтад хамрагдаагүй" },
      ],
      i7arr6126: [
        {id: 0, title: 'Сонгох'},
        { id: 1, title: "Хороод, салбарын үйл ажиллагаанд оролцсон" },
        { id: 2, title: "Олон нийтийн үйл ажиллагаанд оролсон" },
        { id: 3, title: "Сургалт, шалгалтын үйл ажиллагаанд оролцсон" },
        { id: 4, title: "Оролцоогүй бол яагаад, танд ямар санал байна?" },
      ],
      i8arr6126: [
        {id: 0, title: 'Сонгох'},
        { id: 1, title: "1. www.cpta.mn сайт" },
        { id: 2, title: "2. www.members.cpta.mn гишүүний програм" },
        { id: 3, title: "3. “Монгол Улсын Татварын Мэргэшсэн Зөвлөхийн Нийгэмлэг”фэйсбүүк пэйж хуудас" },
        { id: 4, title: "4. Бусад эх сурвалж" },
      ],  
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();

    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    getWindowHeight() {
      let contentSub = 120;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;
    },
    init() {
      request({
        api: { method: "get", url: "member/getEthicReportConfig" },
        store: this.$store,
      }).then((res) => {
        console.log('getEthicReportConfig=> ', res);
        if (res != false) {
          //console.log('getEthicReportConfig=> ', res);
          // if (res.data.hasConfig) {
            this.ethiConfig.obj = res.data;
            this.ethiConfig.rdy = true;
            this.initTypes();
            this.initProfile();
            this.initEthicInfo();
          // } else {
          //   alert("Тайлант хугацаа болоогүй байна.");
          //   //this.$Notice.warning({ title: "Тайлант хугацаа болоогүй байна."});
          // }
          // let _b= res.data.task.b.filter(x=>x.ot==280);
          // if(_b!=undefined && _b.length>0){
          //   this.initBox(_b[0].id);
          // }
        }
      });
    },
    initTypes() {
      request({
        api: { method: "GET", url: "Type/getTreeData" },
        params: {
          key: "stptpCRM",
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.hrm.types = res.data.types;
        }
      });
    },
    initProfile() {
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: this.$store.state.user.userInfo.profileId,
          objectTypeId: 138,
          parentId: 0,
          userId: this.$store.state.user.userId,
        },
        store: this.$store,
      }).then((res) => {
        console.log('initProfile=> ', res, this.$store.state.user.userInfo.profileId, this.$store.state.user.userId);
        if (res != false) {
          this.hrm.obj = res.data.task;
          this.hrm.rdy = true;
          //console.log(res);
        }
      });
    },
    initEthicInfo() {
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: {
          id: this.$store.state.user.userInfo.profileId,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          let b = res.data.task.b.filter((x) => x.ot == 268);
          if (b != undefined) {
            //console.log('step 1', b, b[0].id);
            request({
              api: { method: "GET", url: "task/boxInTaskList" },
              params: { id: b[0].id },
              store: this.$store,
            }).then((res) => {
              if (res != false) {
                this.b = res.data.box;
                //console.log('step 2', res.data.box, b[0].id);
                // request({
                //   api: { method: "GET", url: "task/boxInTaskList" },
                //   params:{ boxId: b[0].id, },
                //   store: this.$store
                // }).then(res => {
                //   if (res != false) {
                this.b = res.data.box;
                //console.log('step 3', res.data.box, b[0].id);

                request({
                  api: { method: "GET", url: "Task/GetInherited" },
                  params: { id: this.b.taskId },
                  store: this.$store,
                }).then((res) => {
                  if (res != false) {
                    this.parentTask = res.data.task;
                    //console.log('step 4', res.data.task);
                  }
                });

                if (res.data.tasks.length) {
                  this.ethicModel.obj = res.data.tasks[0];
                }

                request({
                  api: { method: "GET", url: "Task/GetInherited" },
                  params: {
                    id: this.ethicModel.obj.id,
                    projectId: this.b.projectId,
                    parentId: this.b.taskId,
                    boxId: this.b.id,
                    objectTypeId: this.b.objectTypeId,
                    userId: this.b.parentTaskUserId,
                  },
                  store: this.$store,
                }).then((res) => {
                  if (res != false) {
                    this.ethicModel.obj = res.data.task;
                    this.ethicModel.obj.task = "Ёс зүйн тайлан";
                    //console.log(this.$store.state.app.groupSettings);
                    this.ethicModel.obj.i1 = getConfigValueByKey(
                      this.$store.state.app.groupSettings,
                      "tmzPointReport"
                    );

                    var d = new Date();
                    var year = d.getFullYear();
                    var month = d.getMonth();
                    var day = d.getDate();

                    this.ethicModel.obj.d1 = d;
                    this.ethicModel.obj.d2 = new Date(year + 1, month, day);
                  }
                });

                //}
                //});
              }
            });
          }
        }
      });
    },
    videoNext() {
      if (this.ethiConfig.obj.examId > 0) {
        this.stepCur = 2;
      } else {
        this.stepCur = 3;
      }
    },

    examCongrats() {
      this.stepCur++;
    },
    finishEthic() {
      let errs = [];
      if(this.$store.state.app.activeGroup.id == 6126){
        //if ( !(this.ethicModel.obj.i2 == 1 || this.ethicModel.obj.i2 == -1) ) {
        if ( !(this.ethicModel.obj.too2== 1 || this.ethicModel.obj.too2 == -1) ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if ( !(this.ethicModel.obj.i4 == 1 || this.ethicModel.obj.i4 == -1) ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if ( !(this.ethicModel.obj.i5 == 1 || this.ethicModel.obj.i5 == -1) ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if ( !(this.ethicModel.obj.i2 == 1 || this.ethicModel.obj.i2 == 2 || this.ethicModel.obj.i2 == 3 ) ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if ( !(this.ethicModel.obj.i3 == 1 || this.ethicModel.obj.i3 == 2 || this.ethicModel.obj.i3 == 3 ) ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if ( !(this.ethicModel.obj.i6 == 1 || this.ethicModel.obj.i6 == 2 || this.ethicModel.obj.i6 == 3 ) ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        }

        else if ( !(this.ethicModel.obj.i7== 1 || this.ethicModel.obj.i7 == 2 || this.ethicModel.obj.i7 == 3 || this.ethicModel.obj.i7 == 4) ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if ( !(this.ethicModel.obj.i8== 1 || this.ethicModel.obj.i8 == 2 || this.ethicModel.obj.i8 == 3 || this.ethicModel.obj.i8 == 4) ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        }
      }
      else{
        if (!(this.ethicModel.obj.too1 == 1 || this.ethicModel.obj.too1 == -1)) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if (
          !(this.ethicModel.obj.i2 == 1 || this.ethicModel.obj.i2 == -1)
        ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if (
          !(this.ethicModel.obj.i3 == 1 || this.ethicModel.obj.i3 == -1)
        ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if (
          !(this.ethicModel.obj.i4 == 1 || this.ethicModel.obj.i4 == -1)
        ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if (
          !(this.ethicModel.obj.i5 == 1 || this.ethicModel.obj.i5 == -1)
        ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if (
          !(this.ethicModel.obj.i6 == 1 || this.ethicModel.obj.i6 == -1)
        ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if (
          !(this.ethicModel.obj.i7 == 1 || this.ethicModel.obj.i7 == -1)
        ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if (
          !(this.ethicModel.obj.i8 == 1 || this.ethicModel.obj.i8 == -1)
        ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if (
          !(this.ethicModel.obj.days == 1 || this.ethicModel.obj.days == -1)
        ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        } else if (
          !(this.ethicModel.obj.minutes == 1 || this.ethicModel.obj.minutes == -1)
        ) {
          errs.push("Ёс зүйн мэдүүлэг бүрэн бөглөнө үү !");
        }
      }

      if (errs.length == 0) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Task/PostInherited" },
          data: { model: this.ethicModel.obj },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
              api: { method: "POST", url: "Task/PostInherited" },
              data: { model: this.hrm.obj },
              store: this.$store,
            }).then((res) => {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if (res != false) {
                this.toggleBodyClass("addClass", "dynamic-locker");
                request({
                  api: { method: "POST", url: "TaskInUser/shareUserToTask" },
                  data: {
                    userId: this.$store.state.user.userId,
                    taskId: this.ethiConfig.obj.ethicReportConfig.id,
                  },
                  store: this.$store,
                }).then((res) => {
                  this.toggleBodyClass("removeClass", "dynamic-locker");
                  if (res != false) {
                    Notification.success({
                      title: `Амжилттай`,
                      message: errs[0],
                      duration: 5000,
                      type: "success",
                      position: "top-right",
                      offset: 50,
                    });
                    this.$router.push("/");
                  }
                });
              }
            });
          }
        });
      } else {
        Notification.error({
          title: `Мэдэгдэл`,
          message: errs[0],
          duration: 5000,
          type: "error",
          position: "top-right",
          offset: 50,
        });
      }
    },
  },
};
</script>
